export default "/images/240d155006d84444aa57692ad4a04799.png";